import { useSelector } from "react-redux";
import RangeSlider from "../../../../core/components/RangeSlider";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { RootState } from "../../../../core/store/store";
import { formatDistanceSettingText } from "../../../../core/utilities/distance";
import { useDebouncedConfig } from "../hook/useDebounceConfig";

export const MaximumDistance = () => {
	const { getProfileConfig, user } = useSelector((state: RootState) => state.onboarding);
	const initialValues = getProfileConfig?.search_filters?.max_distance || 1;
	const [maximumDistance, setMaximumDistance] = useDebouncedConfig<number>({
		initialValues,
		buildUpdatedFilters: (settings) => ({
			search_filters: {
				distance: settings,
			},
		}),
	});
	const handleMaximumDistanceChange = (value: number) => {
		setMaximumDistance(value);
	};

	return (
		<>
			<Row
				mainAxisAlignment="between"
				className="mt-8 mb-5"
			>
				<TextComponent
					variant="h2"
					className="font-semibold"
				>
					Distance
				</TextComponent>
				<TextComponent variant="h3">
					{formatDistanceSettingText(maximumDistance, {
						country: user?.country,
						city: user?.city,
					})}
				</TextComponent>
			</Row>
			<RangeSlider
				value={maximumDistance}
				onChange={handleMaximumDistanceChange}
			/>
		</>
	);
};
